import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

const State = new Record({
    courses: null,
    selectedCourse: null,
    centers: null,
});

function getCourseById(courses, id) {
    if (!id) return null;

    return _.find(courses, function (course) {
        return course.id === id;
    });
}

class ApostilasStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_COURSE_FOR_COURSEWARE:
                return state.set('selectedCourse', getCourseById(state.courses, action.courseId));

            case ActionTypes.SELECT_COURSES_FINISH:
                return state
                    .set('courses', action.courses)
                    .set('selectedCourse', null);

            case ActionTypes.SELECT_CENTERS_FINISH:
                return state.set('centers', action.centers);

            default:
                return state;
        }
    }
}

export default new ApostilasStore();



// WEBPACK FOOTER //
// src/stores/ApostilasStore.js